import api from './index'
import {
	axios,
	pureAxios,
	pyAxios
} from '@/utils/request'

export function purchase_apply_AaSpuById(data) {
	return axios({
		url: api.gateway_act + 'purchase_apply/AaSpuById',
		method: 'get',
		params: data
	})
}

export function purchase_apply_listAaSpuByName(data) {
	return axios({
		url: api.gateway_act + 'purchase_apply/listAaSpuByName',
		method: 'get',
		params: data
	})
}

export function purchase_list() {
	return axios({
		url: api.gateway_act + 'purchase/list',
		method: 'get'
	})
}

export function purchase_save(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_apply/save',
		method: 'post',
		data: parameter
	})
}
export function storage_transfer(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/storage_transfer',
		method: 'post',
		data: parameter
	})
}
//固定资产待入库移交
export function purchaseTransfer(parameter) {
	return axios({
		url: '/daily/transfer/purchaseTransfer',
		method: 'post',
		data: parameter
	})
}
//固定资产入库（未移交）
export function storage_no_transfer(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/storage_no_transfer?id=' + parameter,
		method: 'post'
	})
}
//查询采购流程
export function goods_record(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/goods_record?id=' + parameter,
		method: 'get'
	})
}
//查询采购流程
export function purchase_list_delete(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/goods/' + parameter,
		method: 'delete'
	})
}

export function anticipate_goods(parameter) {
	return axios({
		url: api.gateway_act + 'anticipate_goods/save',
		method: 'post',
		data: parameter
	})
}

export function purchase_remove(parameter) {
	return axios({
		url: api.gateway_act + 'purchase/remove',
		method: 'post',
		data: parameter
	})
}

//获取我的申请列表
export function get_my_lis(data) {
	return axios({
		url: api.gateway_act + 'business/list/my',
		method: 'get',
		params: data
	})
}


//删除我的申请
export function remove_my_item(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_apply/remove',
		method: 'post',
		data: parameter
	})
}

// 根据id查询详情
export function purchase_apply_get(parameter) {
	return axios({
		url: api.gateway_act + 'scrapped_apply/biz/' + parameter.id,
		method: 'get',
	})
}

// 采购入库列表
export function selectBizPurchaseApplyList(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/selectBizPurchaseApplyList',
		method: 'get',
		params: parameter
	})
}
// 展示用户为确认的转移待确认记录
export function getUncheckPurchaseListByUser(parameter) {
	return axios({
		url: '/daily/transfer/getUncheckPurchaseListByUser',
		method: 'post',
		data: parameter
	})
}

// 查询移交记录
export function transfer_record(parameter) {
	return axios({
		url: '/act/purchase_list/transfer_record',
		method: 'get',
		params: parameter
	})
}
// 移交确认驳回
export function uncheckPurchase(parameter) {
	return axios({
		url: '/daily/transfer/uncheckPurchase',
		method: 'post',
		data: parameter
	})
}

// export function transfer_record(parameter) {
// 	return axios({
// 		url: api.gateway_act + 'purchase_list/transfer_record',
// 		method: 'get',
// 		params: parameter
// 	})
// }



//采购订货和采购计划
export function selectBizPurchaseList(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/selectBizPurchaseList',
		method: 'get',
		params: parameter
	})
}

//去采购
export function updateBizGoodsInfo(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/updateBizGoodsInfo',
		method: 'post',
		data: parameter
	})
}

//采购查询
export function selectGoodsListAll(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/selectGoodsListAll',
		method: 'get',
		params: parameter
	})
}

//采购验收
export function updateBizGoodsInfoList(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/updateBizGoodsInfoList',
		method: 'post',
		data: parameter
	})
}

export function updateBizGoodsInfoListPlan(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/updateBizGoodsInfoListPlan',
		method: 'post',
		data: parameter
	})
}

//采购验收页面
export function selectBizPurchaseCheck(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/selectBizPurchaseCheck',
		method: 'get',
		params: parameter
	})
}

//申请人验收
export function updateBizGoodsInfoList2(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/updateBizGoodsInfoList2',
		method: 'post',
		data: parameter
	})
}
//采购物品入库
export function updateBizGoodsInfoWarehousing(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/updateBizGoodsInfoWarehousing',
		method: 'post',
		data: parameter
	})
}
//固定资产采购入库
// export function receipt_checkin3(parameter) {
// 	return pyAxios({
// 		url: 'receipt/checkin3',
// 		method: 'post',
// 		data: parameter
// 	})
// }

//固定资产采购申请页面
export function selectGoodsListFixed(parameter) {
	return axios({
		url: api.gateway_act + 'purchase_list/selectGoodsListFixed',
		method: 'get',
		params: parameter
	})
}

// //固定资产采购入库
// export function get_purchase_list(parameter) {
// 	return pyAxios({
// 		url: '/asset/transcation/get_purchase_list',
// 		method: 'get',
// 		data: parameter
// 	})
// }
//固定资产移交
export function keep_storage(parameter) {
	return axios({
		url: '/act/purchase_list/keep_storage',
		method: 'put',
		data: parameter
	})
}
//确认移交
export function check_transfer(parameter) {
	return axios({
		url: '/daily/transfer/checkPurchase',
		method: 'post',
		data: parameter
	})
}
//移交驳回

// export function check_transfer(parameter) {
// 	return axios({
// 		url: '/act/purchase_list/check_transfer',
// 		method: 'put',
// 		data: parameter
// 	})
// }


//流程监控
export function business_list_all(parameter) {
	return axios({
		url: api.gateway_act + 'business/list_all',
		method: 'get',
		params: parameter
	})
}

//查询需求管理
export function business_need(parameter) {
	return axios({
		url: api.gateway_act + 'business/need',
		method: 'get',
		params: parameter
	})
}

//查询本人列表
export function anticipate_goods_listall(parameter) {
	return axios({
		url: api.gateway_act + 'anticipate_goods',
		method: 'get',
		params: parameter
	})
}

//修改预提交
export function anticipate_goods_update(parameter) {
	return axios({
		url: api.gateway_act + 'anticipate_goods/update',
		method: 'post',
		data: parameter
	})
}

//删除预提交
export function anticipate_goods_delete(parameter) {
	return axios({
		url: api.gateway_act + 'anticipate_goods/delete',
		method: 'post',
		data: parameter
	})
}

// 三级下拉
export function tree_all(parameter) {
	return axios({
		url:'system/dept/tree_all',
		method: 'GET',
		params: parameter
	})
}

//查询有权限部门
export function enableParent(parameter) {
	return axios({
		url:'system/dept/list/enable_parent',
		method: 'get',
	})
}
//获取转交列表
export function getReassignment(parameter)  {
	return axios({
		url:'/act/business/reassignment',
		method: 'GET',
		// develop
		params: parameter
	})
}